export default ({ request }) => ({
  // 获取权限树
  getPermissionTree(params) {
    return request({
      url: '/v1/permissions/tree',
      method: 'get',
      params: params
    })
  },

  // 获取权限列表(扁平结构)
  getPermissionList() {
    return request({
      url: '/v1/permissions/list',
      method: 'get'
    })
  },

  // 获取权限详情
  getPermissionDetail(id) {
    return request({
      url: `/v1/permissions/${id}`,
      method: 'get'
    })
  },

  // 创建权限
  createPermission(data) {
    return request({
      url: '/v1/permissions',
      method: 'post',
      data: data
    })
  },

  // 更新权限
  updatePermission(id, data) {
    return request({
      url: `/v1/permissions/${id}`,
      method: 'put',
      data: data
    })
  },

  // 删除权限
  deletePermission(id, params) {
    return request({
      url: `/v1/permissions/${id}`,
      method: 'delete',
      params: params
    })
  },

  // 批量初始化权限
  initializePermissions(data) {
    return request({
      url: '/v1/permissions/initialize',
      method: 'post',
      data: data
    })
  },

  // 获取权限树(前端authority格式)
  getAuthorityTree(params) {
    return request({
      url: '/v1/permissions/authority/tree',
      method: 'get',
      params: params
    })
  },

  // 获取租户权限树(已过滤)
  getTenantPermissionTree(tenantId) {
    return request({
      url: `/v1/permissions/tenant/${tenantId}/tree`,
      method: 'get'
    })
  },

  // 验证权限值有效性
  validatePermissions(data) {
    return request({
      url: '/v1/permissions/validate',
      method: 'post',
      data: data
    })
  },

  // 设置租户权限
  updateTenantPermissions(tenantId, data) {
    return request({
      url: `/v1/tenants/${tenantId}/permissions`,
      method: 'put',
      data: data // 直接使用传入的数据，避免双重包装
    })
  },

  // 获取租户权限
  getTenantPermissions(tenantId) {
    return request({
      url: `/v1/tenants/${tenantId}/permissions`,
      method: 'get'
    })
  },

  // 导入权限数据(JSON格式)
  importPermissions(data) {
    return request({
      url: '/v1/permissions/import',
      method: 'post',
      data: { permissions: data }
    })
  },

  // 导出权限数据(authority格式)
  exportPermissions() {
    return request({
      url: '/v1/permissions/export',
      method: 'get'
    })
  }
})